"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var BannerStyles = _interopRequireWildcard(require("./BannerAdStyles"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _common = require("../../config/common");
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@mui/material/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  BannerButton = props => {
    const {
        buttonTestId,
        customClassNames,
        label,
        onClick,
        path,
        isInjected = false,
        theme,
        url,
        variant = "outline"
      } = props,
      buttonClasses = (0, _classnames.default)({
        "BannerAd__button": true,
        [`${customClassNames}`]: (0, _string.isStringOfLength)(customClassNames),
        [`BannerAd__button--is${variant.substring(0, 1).toUpperCase() + variant.substring(1)}`]: (0, _string.isStringOfLength)(variant)
      }),
      dynamicProps = {
        [_common.HTML_DATA_ATTR_INJECTED]: isInjected ? true : undefined
      },
      ButtonFragment = () => {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: buttonClasses,
          component: _reactRouterDom.Link,
          "data-testid": buttonTestId,
          onClick: onClick,
          to: path,
          variant: variant
        }, label), (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(url) && !(0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
          className: buttonClasses,
          component: "a",
          "data-testid": buttonTestId,
          onClick: onClick,
          href: url,
          target: !isInjected ? "_blank" : undefined,
          variant: variant
        }, dynamicProps), label));
      };
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, theme && /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(ButtonFragment, null)), !theme && /*#__PURE__*/_react.default.createElement(ButtonFragment, null));
  };

/**
	 * Banner Ad that spans the page width, use as a child of the main container
	 *
	 * @visibleName Banner Ad
	 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
	*/
const BannerAd = props => {
  const {
      button,
      children,
      className,
      customCardStyles = {},
      customTheme = {},
      fragmentId,
      image,
      initialTheme = {},
      testId,
      treatAsFooter = false,
      variant = "outline"
    } = props,
    theme = merge.all([initialTheme, (0, _styles.useTheme)(), customTheme]),
    margins = treatAsFooter === true ? {
      marginBottom: "0 !important",
      marginTop: {
        xs: `${theme.contentSpacing.mobileFooter} !important`,
        md: `${theme.contentSpacing.desktopFooter} !important`
      }
    } : {},
    adStyles = merge.all([BannerStyles.BannerAdStyles(theme, variant, image), margins, customCardStyles]),
    classes = (0, _classnames.default)({
      "bannerAd": true,
      [`${className}`]: className,
      [`bannerAd--is${variant.substring(0, 1).toUpperCase() + variant.substring(1)}`]: (0, _string.isStringOfLength)(variant)
    });
  return /*#__PURE__*/_react.default.createElement(_material.Container, {
    className: classes,
    "data-testid": testId,
    sx: adStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "bannerAd__inner"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "bannerAd__image"
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "bannerAd__content"
  }, (fragmentId || children) && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  }), children), button && button.label && /*#__PURE__*/_react.default.createElement(BannerButton, _extends({}, button, {
    theme: (0, _object.isObject)(initialTheme) && Object.keys(initialTheme).length ? theme : undefined
  })))));
};

// Define propTypes;
BannerAd.propTypes = {
  /** Button properties */
  button: _propTypes.default.shape({
    /** Custom button class(es) */
    customClassNames: _propTypes.default.string,
    /** Indicator to mark link with data-inj indicator */
    isInjected: _propTypes.default.bool,
    /** Button Text */
    label: _propTypes.default.string,
    /** Button path, if a React Route */
    path: _propTypes.default.string,
    /** External URL, is applied only if there is no path defined */
    url: _propTypes.default.string,
    /** Button variant type */
    variant: _propTypes.default.string
  }),
  /** Child nodes, renders after content fragment */
  children: _propTypes.default.any,
  /** Custom classes for the component */
  className: _propTypes.default.string,
  /** Custom Style Override (Default Value: {}) */
  customCardStyles: _propTypes.default.object,
  /** Custom theme injection (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Content Fragment ID */
  fragmentId: _propTypes.default.string,
  /** URL to image */
  image: _propTypes.default.string,
  /** Injected theme stub from custom elements */
  intitialTheme: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Indicator to apply footer margins to ad (Default Value: false) */
  treatAsFooter: _propTypes.default.bool,
  /** Ad Variant (Default Value: "outline")  */
  variant: _propTypes.default.string
};
BannerButton.propTypes = {
  buttonTestId: _propTypes.default.string,
  customClassNames: _propTypes.default.string,
  isInjected: _propTypes.default.bool,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func,
  path: _propTypes.default.string,
  variant: _propTypes.default.string,
  url: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = BannerAd;